<template>
    <v-dialog
        width="60%"
        max-width="500"
        :value="lists.show_delete_dialog"
        persistent
    >
        <v-card>
            <v-card-title class="text-h5 primary">
                Delete Contact
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="py-4">
                Are you sure you want to delete the list <strong>{{lists.list_to_delete.post_title}}</strong> and all of its contacts?
                <div v-if="error" class="error--text font-weight-bold">There was an error deleting the list.</div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    @click="lists.show_delete_dialog = false"
                >
                    Cancel
                </v-btn>
                <v-btn
                    color="error"
                    @click="lists.deleteList(lists.list_to_delete.ID)"
                    :loading="loading"
                    :disabled="loading"
                >
                    Delete
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { useListsStore } from '../../stores/lists'

export default {
    name: 'DialogDeleteList',
    props: ['delete_list'],
    data: () => ({
        loading: false,
        showDialog: true,
        error: false,
        lists: null
    }),
    created: function() {
        this.lists = useListsStore()
    }
}
</script>
